import { loadModules } from 'esri-loader';
import { QueryTaskExecuteWithrelation, QueryTaskExecuteBufferWithrelation } from '../util/queryTask';



/**
 * GIS fetch lookup using features
 * @param {*} config - Map configuration
 * @param {*} features - Sketch features/geometry
 * @param {*} validationlayers - Layers to validate against
 * @param {*} validationType - 'POSITIVE' (must be near) or 'NEGATIVE' (must be away)
 */
export function SketchDistanceValidatorTask(config, features, validationlayers, validationType = 'POSITIVE') {
    console.log('Sketch validation for layers *********', validationlayers, 'Type:', validationType)
    let geometries = [];

    //caluclating only on the single geom, need to change for multiple
    geometries.push(features)
    return new Promise((resolve, reject) => {
        if (validationlayers && validationlayers.length > 0) {
            let allPromises = [];

            validationlayers.forEach(function (layer) {
                let ServiceUrl = layer.Url || layer.url;
                let BufferDistance = layer.ValidationDistance;

                let eachpromise = new Promise((resolve, reject) => {
                    let gisFeatureLayer = { url:ServiceUrl,  Token: layer.Token, TokenExpiration: layer.TokenExpiration };                    
                    let queryExpression = "1=1";
                    let inputgeom;

                    //verify geometries and get the center if multiple
                    if (geometries && geometries.length > 1) {
                        inputgeom = geometries[0];
                    } else {
                        inputgeom = geometries[0];
                    }
                    QueryTaskExecuteBufferWithrelation(gisFeatureLayer, queryExpression, config.viewProperties.extent.spatialReference, inputgeom, BufferDistance, "feet").then(
                        response => {    
                            if (response && response.features && response.features.length > 0){
                                resolve({"Layer": layer, "ResponseCount": response.features.length, "ValidationType": validationType});
                            }else{
                                resolve({"Layer": layer, "ResponseCount": 0, "ValidationType": validationType});
                            }
                        },
                        error => {
                            console.log(error);
                            resolve({});
                        }
                    )
                });
                allPromises.push(eachpromise);
            })
            Promise.all(allPromises).then((data) => {               
                resolve(data);
            });
        } else {
            console.log({ error: 'No geometries found to gis lookup task' })
            resolve({});
        }
    })
}
